'use strict';

const resolveTemplate = [
  '$http',
  '$q',
  '$templateCache',

  function ($http, $q, $templateCache) {

    /**
     * Resolves a promise with template content.
     *
     * @param {String} template Template or template url.
     * @returns {promise}
     */
    return function (template) {
      if (/.*\.html/.test(template)) {
        return $http.get(template, {
          cache: $templateCache
        }).then(function (response) {
          return response.data;
        });
      } else {
        return $q.resolve(template);
      }
    };
  }
];

export default resolveTemplate;



// WEBPACK FOOTER //
// ./app/src/services/resolve_template.js